/*
  Savendo product page enhancements
  1. Overlay prev/next arrows on the gallery stage (desktop thumbnail layout,
     where Dawn's slider arrows cannot work because inactive slides are hidden).
  2. Keeps the active thumbnail in view inside the vertical rail.
  3. Reveals the mobile sticky add-to-cart bar once the real button scrolls away.
*/
(function () {
  var CARET =
    '<svg viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
    '<path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function thumbButtons(gallery) {
    return Array.prototype.slice.call(
      gallery.querySelectorAll('[id^="GalleryThumbnails"] .thumbnail-list__item:not([hidden]) button')
    );
  }

  function activeIndex(buttons) {
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].hasAttribute('aria-current')) return i;
    }
    return 0;
  }

  function keepThumbInView(button) {
    var list = button.closest('.thumbnail-list');
    if (!list || list.scrollHeight <= list.clientHeight) return;
    var item = button.parentElement;
    var top = item.offsetTop;
    var bottom = top + item.offsetHeight;
    if (top < list.scrollTop) {
      list.scrollTo({ top: top - 8, behavior: 'smooth' });
    } else if (bottom > list.scrollTop + list.clientHeight) {
      list.scrollTo({ top: bottom - list.clientHeight + 8, behavior: 'smooth' });
    }
  }

  function initGallery(gallery) {
    if (gallery.dataset.savendoArrows === 'true') return;

    var stage = gallery.querySelector('[id^="GalleryViewer"]');
    var buttons = thumbButtons(gallery);
    if (!stage || buttons.length < 2) return;

    gallery.dataset.savendoArrows = 'true';

    ['prev', 'next'].forEach(function (dir) {
      var arrow = document.createElement('button');
      arrow.type = 'button';
      arrow.className = 'savendo-stage-arrow savendo-stage-arrow--' + dir;
      arrow.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
      arrow.innerHTML = CARET;
      arrow.addEventListener('click', function () {
        var current = thumbButtons(gallery);
        if (current.length < 2) return;
        var index = activeIndex(current);
        var next = dir === 'prev' ? (index - 1 + current.length) % current.length : (index + 1) % current.length;
        current[next].click();
        keepThumbInView(current[next]);
      });
      stage.appendChild(arrow);
    });

    // Follow thumbnail changes triggered any other way (clicks, variant swaps).
    gallery.addEventListener('click', function (event) {
      var button = event.target.closest('.thumbnail-list__item button');
      if (button) keepThumbInView(button);
    });
  }

  function initStickyAtc() {
    var bar = document.querySelector('.savendo-sticky-atc');
    if (!bar || bar.dataset.savendoBound === 'true') return;
    bar.dataset.savendoBound = 'true';

    var anchorId = bar.getAttribute('data-anchor');
    var priceSourceId = bar.getAttribute('data-price-source');
    var buttonSourceId = bar.getAttribute('data-button-source');
    var ticking = false;

    /*
      Mirror the real buy box.

      Dawn re-renders the product info block on every variant change, but this
      bar sits outside it, so its server-rendered price and label belong to
      whichever variant happened to be selected on load. On a product where
      some variants are sold out that goes wrong immediately: pick the sold-out
      colour and the real button becomes a disabled "Sold out" while the bar
      still offers "Add to cart" at the old price — and submitting it posts a
      variant Shopify will reject.

      Copying from the live elements rather than tracking variant state keeps
      one source of truth. Whatever Dawn decides the button and price should
      say is what the bar says.
    */
    function mirror() {
      var priceSource = priceSourceId && document.getElementById(priceSourceId);
      var target = bar.querySelector('[data-sv-sticky-price]');
      if (priceSource && target) {
        // Only the sale/regular figure, not the "Sale"/"Sold out" badges that
        // sit alongside it in the same container.
        var item = priceSource.querySelector('.price-item--sale, .price-item--regular');
        var text = (item ? item.textContent : priceSource.textContent).trim();
        if (text && target.textContent.trim() !== text) target.textContent = text;
      }

      var buttonSource = buttonSourceId && document.getElementById(buttonSourceId);
      var button = bar.querySelector('[data-sv-sticky-button]');
      if (buttonSource && button) {
        /*
          Compare before writing. `button.disabled = true` re-sets the content
          attribute even when it is already true, and that counts as an
          attribute mutation. Since this bar lives inside the observed
          <product-info>, an unconditional write fed the observer, which called
          this function, which wrote again — an infinite loop that locked the
          tab. It only ever triggered on a sold-out variant, because writing
          `false` to an already-absent attribute produces no mutation record.
        */
        if (button.disabled !== buttonSource.disabled) {
          button.disabled = buttonSource.disabled;
        }
        var label = buttonSource.querySelector('span:not(.loading__spinner):not(.visually-hidden)');
        var labelText = (label ? label.textContent : buttonSource.textContent).trim();
        var slot = button.querySelector('[data-sv-sticky-button-text]');
        if (slot && labelText && slot.textContent.trim() !== labelText) {
          slot.textContent = labelText;
        }
      }
    }

    function update() {
      ticking = false;
      // Resolved on every pass: product-info.js replaces the buy box on variant change.
      var anchor = anchorId && document.getElementById(anchorId);
      if (!anchor) return;
      bar.classList.toggle('is-visible', anchor.getBoundingClientRect().bottom < 0);
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );

    /*
      The buy box is swapped wholesale on variant change, so observing the
      container rather than the button survives the replacement. Subtree
      character data covers the price re-rendering in place.
    */
    var host = document.querySelector('product-info, .product__info-container') || document.body;
    if (window.MutationObserver) {
      /*
        Ignore mutations this bar caused itself. The equality guards in mirror()
        already stop the feedback loop, but the bar is a descendant of the
        observed host, so without this every cosmetic change to it still wakes
        the observer. Belt and braces: a future edit that writes to the bar
        without comparing first cannot reintroduce the hang.
      */
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          if (!bar.contains(records[i].target)) {
            mirror();
            return;
          }
        }
      }).observe(host, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled', 'class'],
      });
    }
    document.addEventListener('change', mirror);

    mirror();
    update();
  }

  /* ---- Watchlist ---------------------------------------------------------
     Stored in the shopper's own browser. A theme has no server-side storage,
     so this is per-device and deliberately does not claim to be anything more.
     ------------------------------------------------------------------------ */

  var WATCH_KEY = 'savendo:watchlist';

  function readWatchlist() {
    try {
      var raw = window.localStorage.getItem(WATCH_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      // Private browsing, disabled storage, or corrupt JSON — fail silently.
      return [];
    }
  }

  function writeWatchlist(list) {
    try {
      window.localStorage.setItem(WATCH_KEY, JSON.stringify(list));
      document.dispatchEvent(new CustomEvent('savendo:watchlist:change', { detail: { count: list.length } }));
      return true;
    } catch (error) {
      return false;
    }
  }

  function paintWatchButton(button, saved) {
    var label = button.querySelector('[data-sv-watch-label]');
    var title = button.dataset.productTitle || 'this item';
    button.classList.toggle('is-watched', saved);
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    button.setAttribute('aria-label', (saved ? 'Remove ' : 'Add ') + title + (saved ? ' from' : ' to') + ' your watchlist');
    if (label) label.textContent = saved ? 'Watching' : 'Watch';
  }

  function initWatch() {
    document.querySelectorAll('[data-sv-watch]').forEach(function (button) {
      var id = button.dataset.productId;
      if (!id) return;

      var list = readWatchlist();
      paintWatchButton(
        button,
        list.some(function (item) {
          return String(item.id) === String(id);
        })
      );

      if (button.dataset.svBound === 'true') return;
      button.dataset.svBound = 'true';

      button.addEventListener('click', function () {
        var current = readWatchlist();
        var index = -1;
        current.forEach(function (item, i) {
          if (String(item.id) === String(id)) index = i;
        });

        if (index > -1) {
          current.splice(index, 1);
        } else {
          current.push({
            id: id,
            handle: button.dataset.productHandle,
            title: button.dataset.productTitle,
            at: Date.now(),
          });
        }

        var nowWatching = index === -1;
        if (writeWatchlist(current)) {
          paintWatchButton(button, nowWatching);
          // savendo-counters.js relays this to the counter worker, so the
          // watcher total reflects everyone, not just this browser.
          document.dispatchEvent(
            new CustomEvent('savendo:watch', { detail: { id: id, watching: nowWatching } })
          );
        }
      });
    });
  }

  /*
    Long descriptions are clamped to well under a screen, with a fade and a
    Show more toggle. The button only appears when the content actually
    overflows the clamp — a short description never shows a pointless button.
    Re-measured on window load because description images finish sizing late.
  */
  function initDescClamp() {
    var clamp = document.querySelector('[data-sv-desc]');
    var toggle = document.querySelector('[data-sv-desc-toggle]');
    if (!clamp || !toggle || toggle.dataset.svBound === 'true') return;
    toggle.dataset.svBound = 'true';

    function measure() {
      if (clamp.classList.contains('is-open')) return;
      toggle.hidden = clamp.scrollHeight <= clamp.clientHeight + 40;
    }

    measure();
    window.addEventListener('load', measure);

    toggle.addEventListener('click', function () {
      var open = clamp.classList.toggle('is-open');
      toggle.textContent = open ? 'Show less' : 'Show more';
      // Collapsing from deep inside a long read would strand the viewport
      // far below the section — walk back to the top of the description.
      if (!open) clamp.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /*
    The activity badge shows a single metric by priority, so watchers stay
    hidden whenever views or carts outrank them. Mirror the real total onto
    the heart itself, where it is always visible. Fed by savendo-counters.js,
    which emits the server's figure — never a local guess.
  */

  /* ---- Gallery controls --------------------------------------------------
     Expand owns no modal logic of its own. It locates the currently active
     media's Dawn toggle and clicks it, so <modal-opener> still calls
     modal.show(button) with that button as the opener — which is what makes
     Dawn return focus to the right control when the modal closes.

     Falls back to the first toggle when nothing is marked active, which is the
     state on first paint before media-gallery.js has run.
     ---------------------------------------------------------------------- */
  /*
    Set while Expand drives Dawn's toggle programmatically. The inline-zoom
    interceptor below swallows clicks on that same toggle on desktop, so
    without this flag Expand would zoom the image instead of opening the
    modal — the two controls share one underlying button.
  */
  var svAllowModal = false;

  function initGalleryControls() {
    document.querySelectorAll('[data-sv-expand]').forEach(function (button) {
      if (button.dataset.svBound === 'true') return;
      button.dataset.svBound = 'true';

      button.addEventListener('click', function () {
        var gallery = document.querySelector('media-gallery');
        if (!gallery) return;

        /*
          Open on what the shopper is LOOKING AT, which on a phone is not
          necessarily what Dawn calls active. A swipe scrolls the slider but
          never moves `is-active` — that only changes through setActiveMedia —
          so after swiping to image 3 the viewer opened on image 1.

          The slider's settled page is the truth when it exists; is-active
          remains the fallback for desktop, where there is no slider to consult.
        */
        var toggle = null;
        var slider = gallery.querySelector('slider-component');
        var items = [].slice.call(gallery.querySelectorAll('.product__media-item'));

        /*
          Only trust the slider where it can actually scroll. On a landscape
          phone Dawn renders its wide layout, so the slider exists but never
          moves and currentPage is permanently 1 — preferring it there would
          make Expand ignore the arrows and always open on the first image.
        */
        var list = gallery.querySelector('[id^="Slider-Gallery"]');
        var scrollable = list && list.scrollWidth > list.clientWidth + 4;
        if (scrollable && slider && slider.currentPage && items[slider.currentPage - 1]) {
          toggle = items[slider.currentPage - 1].querySelector('.product__media-toggle');
        }
        if (!toggle) {
          var active = gallery.querySelector('.product__media-item.is-active');
          toggle = (active || gallery).querySelector('.product__media-toggle');
        }
        if (!toggle) toggle = gallery.querySelector('.product__media-toggle');
        if (!toggle) return;

        /*
          Dawn's ModalDialog restores focus to whatever it recorded as
          `openedBy`, which after a programmatic click is the invisible media
          toggle rather than the control the shopper actually pressed. Closing
          the viewer therefore dropped focus onto the image instead of Expand.

          Reassigning openedBy afterwards is safe: show() has already called
          showActiveMedia() synchronously by this point, and the media id is
          copied across first so any later call still resolves the right slide.
        */
        // Inline zoom and the fullscreen viewer are different answers to the
        // same question; leaving both on at once is disorienting.
        resetInlineZoom();

        svAllowModal = true;
        toggle.click();
        svAllowModal = false;

        var modal = document.querySelector('product-modal');
        if (modal && modal.openedBy === toggle) {
          var mediaId = toggle.getAttribute('data-media-id');
          if (mediaId) button.setAttribute('data-media-id', mediaId);
          modal.openedBy = button;
        }
      });
    });
  }

  /* ---- Watchlist announcements -------------------------------------------
     aria-pressed tells a screen reader the control's state when it is focused,
     but not that the state just changed. A polite live region announces the
     result of the action itself, which is the part a non-sighted shopper would
     otherwise have to go looking for.
     ---------------------------------------------------------------------- */
  function watchLiveRegion() {
    var region = document.getElementById('sv-watch-live');
    if (region) return region;
    region = document.createElement('div');
    region.id = 'sv-watch-live';
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('role', 'status');
    region.className = 'visually-hidden';
    document.body.appendChild(region);
    return region;
  }

  document.addEventListener('savendo:watch', function (event) {
    if (!event.detail) return;
    watchLiveRegion().textContent = event.detail.watching
      ? 'Saved to your watchlist'
      : 'Removed from your watchlist';
  });


  /* ---- Desktop inline zoom -----------------------------------------------
     Click the product image to magnify it in place, inside the media stage.

     WHY IT INTERCEPTS DAWN'S TOGGLE
     `.product__media-toggle` is a full-bleed button over each image, wired by
     Dawn's <modal-opener> to open the lightbox. That is the only element the
     shopper can actually click, so desktop zoom has to take that click over.
     The listener is registered in the CAPTURE phase on <media-gallery>: an
     ancestor capture handler runs before the target's own listener, so
     stopPropagation() there reliably prevents modal-opener from firing.
     Registering on the button itself would not be reliable — at the target,
     capture and bubble listeners run in registration order.

     Desktop only. Below 990px the handler returns immediately and the tap
     falls through to Dawn untouched.

     No library, no second image element, no canvas: one CSS transform on the
     image already in the DOM, with transform-origin following the pointer.
     Because origin is expressed as a percentage of the element, the scaled
     image always covers the frame — no blank edges to constrain against.
     ---------------------------------------------------------------------- */
  var SV_DESKTOP = '(min-width: 990px)';
  var SV_ZOOM = 2.4;
  var svZoomed = null; // the <img> currently magnified

  function isDesktop() {
    return window.matchMedia(SV_DESKTOP).matches;
  }

  function setOriginFromEvent(img, event) {
    var box = img.getBoundingClientRect();
    var x = ((event.clientX - box.left) / box.width) * 100;
    var y = ((event.clientY - box.top) / box.height) * 100;
    img.style.transformOrigin =
      Math.max(0, Math.min(100, x)) + '% ' + Math.max(0, Math.min(100, y)) + '%';
  }

  /*
    The loaded candidate is chosen for the image's LAYOUT width, so magnifying
    it 2.4x shows roughly 2.4x fewer real pixels per screen pixel — a 632px
    source stretched past 1500px. The upgrade is fetched only on the first
    zoom of a given image, never on page load, and is picked from the srcset
    candidates Shopify already offers rather than inventing a URL.
  */
  function upgradeSource(img) {
    if (img.dataset.svHires === 'done' || img.dataset.svHires === 'pending') return;
    var current = img.currentSrc || img.src;
    if (!current || current.indexOf('width=') === -1) return;

    var need = Math.round(img.getBoundingClientRect().width * SV_ZOOM * (window.devicePixelRatio || 1));
    var candidates = (img.getAttribute('srcset') || '')
      .split(',')
      .map(function (part) {
        var m = part.trim().match(/width=(\d+)/);
        return m ? parseInt(m[1], 10) : 0;
      })
      .filter(Boolean)
      .sort(function (a, b) { return a - b; });
    if (!candidates.length) return;

    var target = candidates[candidates.length - 1];
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i] >= need) { target = candidates[i]; break; }
    }
    var currentWidth = parseInt((current.match(/width=(\d+)/) || [0, 0])[1], 10);
    if (target <= currentWidth) { img.dataset.svHires = 'done'; return; }

    var url = current.replace(/width=\d+/, 'width=' + target);
    img.dataset.svHires = 'pending';
    var pre = new Image();
    pre.onload = function () {
      // Swapped only once decoded, so the visible image never flashes.
      img.setAttribute('srcset', url + ' ' + target + 'w');
      img.setAttribute('src', url);
      img.dataset.svHires = 'done';
    };
    pre.onerror = function () { img.dataset.svHires = 'done'; };
    pre.src = url;
  }

  /*
    Dawn labels every media toggle "Open media N in modal". On desktop this
    controller takes that click over and magnifies the image in place, so the
    name has to describe what the button actually does — otherwise a
    screen-reader user is told it opens a lightbox that it never opens. The
    name only became correct after a first zoom, which is exactly the user who
    could not have known to try.

    Dawn's own wording is stashed so it comes back when the viewport drops
    below the desktop breakpoint and Dawn's behaviour returns. Writes
    textContent, never a class, so the media observer below cannot see it.
  */
  function labelToggles() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    var toggles = gallery.querySelectorAll('.product__media-toggle');
    for (var i = 0; i < toggles.length; i++) {
      var hidden = toggles[i].querySelector('.visually-hidden');
      if (!hidden) continue;
      if (typeof hidden.dataset.svDawnLabel === 'undefined') {
        hidden.dataset.svDawnLabel = hidden.textContent;
      }
      var item = toggles[i].closest('.product__media-item');
      if (!isDesktop()) {
        hidden.textContent = hidden.dataset.svDawnLabel;
      } else if (svZoomed && item && item.contains(svZoomed)) {
        hidden.textContent = 'Reset product image zoom';
      } else {
        hidden.textContent = 'Zoom product image';
      }
    }
  }

  function applyInlineZoom(img, event) {
    svZoomed = img;
    upgradeSource(img);
    setOriginFromEvent(img, event);
    img.style.transform = 'scale(' + SV_ZOOM + ')';
    var stage = img.closest('.product-media-container');
    if (stage) stage.classList.add('sv-zoomed');
    var toggle = img.closest('.product__media-item, media-gallery');
    toggle = toggle && toggle.querySelector('.product__media-toggle');
    if (toggle) {
      var hidden = toggle.querySelector('.visually-hidden');
      if (hidden) hidden.textContent = 'Reset product image zoom';
    }
  }

  function resetInlineZoom() {
    if (!svZoomed) return;
    var img = svZoomed;
    svZoomed = null;
    img.style.transform = '';
    img.style.transformOrigin = '';
    var stage = img.closest('.product-media-container');
    if (stage) stage.classList.remove('sv-zoomed');
    var item = img.closest('.product__media-item, media-gallery');
    var toggle = item && item.querySelector('.product__media-toggle');
    if (toggle) {
      var hidden = toggle.querySelector('.visually-hidden');
      if (hidden) hidden.textContent = 'Zoom product image';
    }
  }

  function initInlineZoom() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery || gallery.dataset.svZoomBound === 'true') return;
    gallery.dataset.svZoomBound = 'true';

    gallery.addEventListener(
      'click',
      function (event) {
        if (!isDesktop() || svAllowModal) return;
        var toggle = event.target.closest && event.target.closest('.product__media-toggle');
        if (!toggle) return;
        event.preventDefault();
        event.stopPropagation();

        var img = toggle.closest('.product__media-item, media-gallery').querySelector('.product__media img');
        if (!img) return;
        if (svZoomed === img) resetInlineZoom();
        else applyInlineZoom(img, event);
      },
      true
    );

    // Inspect other parts of the enlarged image by moving the pointer.
    gallery.addEventListener('mousemove', function (event) {
      if (!svZoomed || !isDesktop()) return;
      setOriginFromEvent(svZoomed, event);
    });

    // Any change of the displayed media invalidates the zoom. Watching the
    // active class covers thumbnails, prev/next and variant swaps alike.
    if (window.MutationObserver) {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var target = records[i].target;
          /*
            Only Dawn's own media switching counts. applyInlineZoom() adds
            `sv-zoomed` to the media container, which is itself a class
            mutation inside this subtree — without this filter the zoom
            immediately observed its own arrival and reset itself, so the
            image never appeared magnified at all.

            `.product__media-item` is the element Dawn toggles `is-active` on,
            and it is never the element this controller writes to.
          */
          if (
            records[i].attributeName === 'class' &&
            target.classList &&
            target.classList.contains('product__media-item')
          ) {
            resetInlineZoom();
            labelToggles();
            return;
          }
        }
      }).observe(gallery, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    var mql = window.matchMedia(SV_DESKTOP);
    var onBreak = function () {
      if (!mql.matches) resetInlineZoom();
      labelToggles();
    };
    if (mql.addEventListener) mql.addEventListener('change', onBreak);
    else if (mql.addListener) mql.addListener(onBreak);

    /*
      Escape clears the zoom and nothing else. When the modal is open Dawn owns
      Escape, so this stands aside — closing the viewer must not also be
      swallowed by an inline-zoom reset.
    */
    labelToggles();

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !svZoomed) return;
      var modal = document.querySelector('product-modal');
      if (modal && modal.hasAttribute('open')) return;
      resetInlineZoom();
      event.stopPropagation();
    });
  }


  /* ---- Fullscreen gallery controller -------------------------------------
     Drives Dawn's product-modal as a one-at-a-time viewer.

     STATE IS NOT DUPLICATED. The modal's own <img data-media-id> elements are
     the list, and the media id is the only identity used. On close the choice
     is handed back to Dawn via MediaGallery.setActiveMedia(), so the PDP
     gallery, its thumbnails and Dawn's live region all update through the code
     that already owns them.
     ---------------------------------------------------------------------- */
  function initModalGallery() {
    var modal = document.querySelector('product-modal');
    if (!modal || modal.dataset.svBound === 'true') return;
    modal.dataset.svBound = 'true';

    /*
      Dawn's ModalDialog gives anything with class `media-modal` a
      click-anywhere-to-close behaviour: a mouse pointerup that is not inside
      deferred-media or product-model calls hide(). The lightbox was previously
      just images, so that was reasonable — but it means every control added to
      the viewer dismisses it. Clicking Next advanced the slide and closed the
      gallery in the same gesture.

      Stopping propagation at the control keeps Dawn's listener, which sits on
      the modal element itself, from ever seeing these events. Clicking the
      backdrop still closes, which is the behaviour worth keeping. Registered
      in the capture phase so it applies before anything else reacts.
    */
    modal.addEventListener(
      'pointerup',
      function (event) {
        if (event.target.closest && event.target.closest('.sv-modal__bar, .sv-modal__nav, .sv-modal__thumbs')) {
          event.stopPropagation();
        }
      },
      true
    );

    var content = modal.querySelector('.product-media-modal__content');
    var counter = modal.querySelector('[data-sv-modal-counter]');
    var prev = modal.querySelector('[data-sv-modal-prev]');
    var next = modal.querySelector('[data-sv-modal-next]');
    if (!content) return;

    /*
      READ LIVE, NEVER CACHE.

      Selecting a variant re-renders `.product-media-modal__content` — the new
      variant's media is rendered first and the rest follow. An array captured
      at bind time therefore held detached nodes afterwards: show() moved
      `active` between elements that were no longer in the document, so the
      counter climbed and the rail followed while the picture on screen never
      changed. Querying on each call costs nothing at this size and cannot go
      stale.
    */
    function slidesNow() {
      return [].slice.call(content.children).filter(function (el) {
        return el.getAttribute && el.getAttribute('data-media-id');
      });
    }

    function thumbsNow() {
      return [].slice.call(modal.querySelectorAll('[data-sv-modal-thumb]'));
    }

    if (!slidesNow().length) return;

    /*
      The rail is server-rendered in the order the stage had at page load. A
      variant change re-renders the stage but leaves the rail alone, so thumb 1
      and slide 1 stopped being the same picture. Both are keyed by media id,
      so no thumbnail ever opened the wrong image — but the position numbers
      disagreed with each other. Reordering the rail to the stage restores one
      order, and renumbers the labels that quote a position.
    */
    function syncRailOrder() {
      var list = modal.querySelector('.sv-modal__thumbs-list');
      if (!list) return;
      slidesNow().forEach(function (slide) {
        var id = slide.getAttribute('data-media-id');
        var btn = list.querySelector('[data-sv-modal-thumb][data-media-id="' + id + '"]');
        var item = btn && btn.closest('.sv-modal__thumbs-item');
        if (item) list.appendChild(item);
      });
      thumbsNow().forEach(function (btn, i) {
        var label = btn.getAttribute('aria-label') || '';
        if (/\d+\s*$/.test(label)) {
          btn.setAttribute('aria-label', label.replace(/\d+\s*$/, '') + (i + 1));
        }
      });
    }

    function indexOfActive() {
      var list = slidesNow();
      for (var i = 0; i < list.length; i++) {
        if (list[i].classList.contains('active')) return i;
      }
      return 0;
    }

    function show(index, announce) {
      var slides = slidesNow();
      if (index < 0 || index >= slides.length) return;
      var id = slides[index].getAttribute('data-media-id');

      // A new media always begins at 1x, centred and whole.
      if (typeof modal.svResetZoom === 'function') modal.svResetZoom(false);
      slides.forEach(function (el) { el.style.transform = ''; el.style.transition = ''; });

      slides.forEach(function (el, i) { el.classList.toggle('active', i === index); });

      if (counter && announce !== false) {
        counter.textContent = index + 1 + ' of ' + slides.length;
      }

      thumbsNow().forEach(function (t) {
        var on = t.getAttribute('data-media-id') === id;
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && t.scrollIntoView) {
          t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      });

      // Gallery does not wrap, so the ends are dead ends and say so.
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    }

    function step(delta) {
      show(indexOfActive() + delta);
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    // Delegated: the rail can be re-rendered or reordered under us.
    modal.addEventListener('click', function (event) {
      var t = event.target.closest && event.target.closest('[data-sv-modal-thumb]');
      if (!t) return;
      var id = t.getAttribute('data-media-id');
      var slides = slidesNow();
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === id) { show(i); return; }
      }
    });

    document.addEventListener('keydown', function (event) {
      if (!modal.hasAttribute('open')) return;
      if (event.key === 'ArrowLeft') { step(-1); event.preventDefault(); }
      else if (event.key === 'ArrowRight') { step(1); event.preventDefault(); }
      else if (event.key === 'Home') { show(0); event.preventDefault(); }
      else if (event.key === 'End') { show(slidesNow().length - 1); event.preventDefault(); }
    });

    /* ---- Touch gesture controller (mobile) -------------------------------
       ONE state machine owns every transform on the active fullscreen image.
       Swipe, pan, pinch and double-tap all route through it, so a gesture can
       never both pan the picture and change slide.

       Touch Events rather than Pointer Events: multi-touch pointer handling
       still differs enough between iOS Safari and Android Chrome that the
       two-finger path needs per-engine special cases, whereas TouchEvent's
       `touches` list behaves the same on both. One model, no branching.

       Only the <img> is transformed. The bar, counter, arrows, rail and close
       button live outside the stage and never scale, so close stays reachable
       at maximum zoom.
       -------------------------------------------------------------------- */
    var MAX_SCALE = 3.2;
    var ZOOM_STEP = 2.5;
    var z = { scale: 1, tx: 0, ty: 0, startDist: 0, startScale: 1, startTx: 0, startTy: 0,
              panX: 0, panY: 0, panning: false, pinching: false, lastTap: 0, lastX: 0, lastY: 0 };

    function activeImg() {
      return slidesNow()[indexOfActive()];
    }

    function reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    /*
      Bounds are derived from the rendered image and the stage, never from
      fixed pixel numbers: at scale s the image overflows the stage by
      (w*s - stageW)/2 on each side, and that overflow is exactly how far it
      may travel before a blank edge appears.
    */
    function clampTranslation() {
      var img = activeImg();
      if (!img) return;
      var stage = content.getBoundingClientRect();
      var w = img.offsetWidth * z.scale;
      var h = img.offsetHeight * z.scale;
      var maxX = Math.max(0, (w - stage.width) / 2);
      var maxY = Math.max(0, (h - stage.height) / 2);
      z.tx = Math.max(-maxX, Math.min(maxX, z.tx));
      z.ty = Math.max(-maxY, Math.min(maxY, z.ty));
    }

    function renderTransform(animate) {
      var img = activeImg();
      if (!img) return;
      img.style.transition = animate && !reducedMotion() ? 'transform 0.2s ease-out' : '';
      img.style.transform =
        'translate(' + z.tx + 'px,' + z.ty + 'px) scale(' + z.scale + ')';
      content.classList.toggle('sv-zoomed-stage', z.scale > 1.01);
    }

    function resetZoom(animate) {
      z.scale = 1; z.tx = 0; z.ty = 0; z.panning = false; z.pinching = false;
      renderTransform(animate);
    }

    function isZoomed() {
      return z.scale > 1.01;
    }

    /*
      Scale about a point: the content under (cx, cy) stays put because the
      translation is adjusted by how much that point moves as the image grows.
    */
    function setScaleAbout(next, cx, cy, animate) {
      var img = activeImg();
      if (!img) return;
      next = Math.max(1, Math.min(MAX_SCALE, next));
      var rect = img.getBoundingClientRect();
      var originX = cx - (rect.left + rect.width / 2);
      var originY = cy - (rect.top + rect.height / 2);
      var ratio = next / z.scale;
      z.tx = z.tx - originX * (ratio - 1);
      z.ty = z.ty - originY * (ratio - 1);
      z.scale = next;
      // Anything within a hair of 1 settles to exactly 1 and re-centres.
      if (z.scale <= 1.01) { z.scale = 1; z.tx = 0; z.ty = 0; }
      clampTranslation();
      renderTransform(animate);
      if (z.scale > 1.01) ensureImageResolution(img);
    }

    /*
      Resolution is chosen per image and per device, from the candidates
      Shopify already advertises. Nothing is fetched on open at 1x, nothing is
      preloaded for neighbouring slides, and a media that already holds an
      adequate candidate is never re-fetched or downgraded.
    */
    function ensureImageResolution(img) {
      if (img.dataset.svUpgrading === '1') return;

      var needed = Math.round(img.getBoundingClientRect().width * MAX_SCALE * (window.devicePixelRatio || 1));

      /*
        naturalWidth is the resolution actually decoded, whatever the URL looks
        like — more reliable than parsing `width=` out of it. On a phone the
        browser often picks the bare original from srcset, which carries no
        width parameter at all; reading the URL made that look like zero and
        skipped the check by accident rather than by decision.
      */
      var have = img.naturalWidth || 0;
      if (have >= needed) return;

      var candidates = (img.getAttribute('srcset') || '')
        .split(',')
        .map(function (part) {
          var m = part.trim().match(/\s(\d+)w\s*$/);
          return m ? parseInt(m[1], 10) : 0;
        })
        .filter(Boolean)
        .sort(function (a, b) { return a - b; });
      if (!candidates.length) return;

      var sourceMax = candidates[candidates.length - 1];
      /*
        Capped by the asset, not by ambition. When the largest candidate is
        already loaded there is nothing better to fetch, and upscaling a URL
        past the source would return the same pixels at a bigger file size.
        Zoom still works; it simply shows the detail the photograph has.
      */
      if (have >= sourceMax) return;

      // Smallest adequate candidate, or the source cap when none suffices.
      var target = sourceMax;
      for (var i = 0; i < candidates.length; i++) {
        if (candidates[i] >= needed) { target = candidates[i]; break; }
      }
      if (target <= have) return;

      var base = img.currentSrc || img.src;
      var url = base.indexOf('width=') > -1
        ? base.replace(/width=\d+/, 'width=' + target)
        : base + (base.indexOf('?') > -1 ? '&' : '?') + 'width=' + target;

      img.dataset.svUpgrading = '1';
      var pre = new Image();
      pre.onload = function () {
        img.setAttribute('srcset', url + ' ' + target + 'w');
        img.setAttribute('src', url);
        img.dataset.svUpgrading = '0';
      };
      pre.onerror = function () { img.dataset.svUpgrading = '0'; };
      pre.src = url;
    }

    function distance(t1, t2) {
      var dx = t1.clientX - t2.clientX, dy = t1.clientY - t2.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    var swipeX = null, swipeY = null;

    content.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        z.pinching = true;
        z.panning = false;
        z.startDist = distance(e.touches[0], e.touches[1]);
        z.startScale = z.scale;
        e.preventDefault();
        return;
      }
      if (e.touches.length !== 1) return;

      var t = e.touches[0];
      var now = Date.now();
      // Double tap: two taps close together in time and place.
      if (now - z.lastTap < 300 && Math.abs(t.clientX - z.lastX) < 30 && Math.abs(t.clientY - z.lastY) < 30) {
        z.lastTap = 0;
        if (isZoomed()) resetZoom(true);
        else setScaleAbout(ZOOM_STEP, t.clientX, t.clientY, true);
        e.preventDefault();
        return;
      }
      z.lastTap = now; z.lastX = t.clientX; z.lastY = t.clientY;

      if (isZoomed()) {
        z.panning = true;
        z.panX = t.clientX; z.panY = t.clientY;
        z.startTx = z.tx; z.startTy = z.ty;
        swipeX = null;
      } else {
        swipeX = t.clientX; swipeY = t.clientY;
      }
    }, { passive: false });

    content.addEventListener('touchmove', function (e) {
      if (z.pinching && e.touches.length === 2) {
        var d = distance(e.touches[0], e.touches[1]);
        if (!z.startDist) return;
        var cx = (e.touches[0].clientX + e.touches[1].clientX) / 2;
        var cy = (e.touches[0].clientY + e.touches[1].clientY) / 2;
        setScaleAbout(z.startScale * (d / z.startDist), cx, cy, false);
        e.preventDefault();
        return;
      }
      if (z.panning && e.touches.length === 1) {
        var t = e.touches[0];
        z.tx = z.startTx + (t.clientX - z.panX);
        z.ty = z.startTy + (t.clientY - z.panY);
        clampTranslation();
        renderTransform(false);
        e.preventDefault();
      }
    }, { passive: false });

    content.addEventListener('touchend', function (e) {
      if (z.pinching && e.touches.length < 2) {
        z.pinching = false;
        z.startDist = 0;
        if (z.scale <= 1.01) resetZoom(true);
        return;
      }
      if (z.panning) {
        if (e.touches.length === 0) z.panning = false;
        return;
      }
      /*
        Swipe only ever runs at 1x. Threshold-gated and horizontal-dominant so
        a tap or a vertical drag never changes slide — and because panning is
        handled above, one gesture can never both move the image and navigate.
      */
      if (swipeX === null || !e.changedTouches.length || isZoomed()) { swipeX = null; return; }
      var dx = e.changedTouches[0].clientX - swipeX;
      var dy = e.changedTouches[0].clientY - swipeY;
      swipeX = null;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
      step(dx < 0 ? 1 : -1);
    }, { passive: true });

    /* ---- Fullscreen desktop click-zoom (mouse only) ----------------------
       The SAME image element, the same z state and the same primitives the
       touch controller uses — setScaleAbout, clampTranslation,
       renderTransform, ensureImageResolution. No clone, no canvas, no second
       modal, no library. Only the gesture differs: mouse gets click-to-zoom
       and pointer-follow inspection, touch keeps pinch/double-tap/pan.

       WHY THE CLICK MUST BE STOPPED
       Dawn's ModalDialog closes `media-modal` on any pointerup that is not
       inside deferred-media or product-model. The image is neither, so
       clicking the picture dismissed the viewer — with a `zoom-out` cursor
       inherited from the modal inviting exactly that click. Phase 3 stopped
       propagation for the bar, nav and thumbnails but not for the image
       itself, because at that point the image had nothing to click for.

       Backdrop-to-close is deliberately preserved: only events on the active
       image are withheld from Dawn.
       -------------------------------------------------------------------- */
    var DESKTOP_POINTER = '(hover: hover) and (pointer: fine)';
    var CLICK_ZOOM = 2.4; // matches the PDP inline zoom, so the two feel alike

    function finePointer() {
      return window.matchMedia(DESKTOP_POINTER).matches;
    }

    function isActiveImage(target) {
      var img = activeImg();
      return !!img && (target === img || (img.contains && img.contains(target)));
    }

    /*
      Inspection by pointer position rather than by drag: the pointer's place
      across the stage maps to a place in the enlarged image, bounded by the
      same clamp the touch pan uses, so no blank region can ever be exposed.
    */
    function panToPointer(clientX, clientY) {
      var img = activeImg();
      if (!img) return;
      var stage = content.getBoundingClientRect();
      var fx = (clientX - stage.left) / stage.width - 0.5;
      var fy = (clientY - stage.top) / stage.height - 0.5;
      var maxX = Math.max(0, (img.offsetWidth * z.scale - stage.width) / 2);
      var maxY = Math.max(0, (img.offsetHeight * z.scale - stage.height) / 2);
      z.tx = -fx * 2 * maxX;
      z.ty = -fy * 2 * maxY;
      clampTranslation();
      renderTransform(false);
    }

    // Capture phase, on the modal: ahead of Dawn's own close listener.
    modal.addEventListener('pointerup', function (event) {
      if (!finePointer() || event.pointerType === 'touch') return;
      if (!isActiveImage(event.target)) return;
      event.stopPropagation();
    }, true);

    content.addEventListener('click', function (event) {
      if (!finePointer()) return;
      if (!isActiveImage(event.target)) return;
      event.preventDefault();
      event.stopPropagation();
      if (isZoomed()) resetZoom(true);
      else setScaleAbout(CLICK_ZOOM, event.clientX, event.clientY, true);
    });

    content.addEventListener('mousemove', function (event) {
      if (!finePointer() || !isZoomed()) return;
      panToPointer(event.clientX, event.clientY);
    });

    // Stale translation is meaningless against a new viewport.
    window.addEventListener('orientationchange', function () { resetZoom(false); });

    // Expose for show()/close, which must always start a media at 1x.
    modal.svResetZoom = resetZoom;

    /*
      Hand the selection back to Dawn on close. setActiveMedia is the same call
      a thumbnail click makes, so the PDP gallery, its thumbnail rail and the
      live region all update through Dawn's own path rather than a second one.
    */
    function syncBack() {
      var gallery = document.querySelector('media-gallery');
      if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
      var current = slidesNow()[indexOfActive()];
      var id = current && current.getAttribute('data-media-id');
      if (!id) return;

      /*
        setActiveMedia expects the gallery item's own data-media-id, which is
        "<sectionId>-<mediaId>" — not the media id the modal slides carry.
        Composing it by hand produced an id that matched nothing, and Dawn then
        dereferenced null.parentElement. Reading it off the matching item keeps
        the two id schemes from having to agree.
      */
      var item = gallery.querySelector('.product__media-item[data-media-id$="-' + id + '"]');
      if (!item) return;
      /*
        prepend:false. Passing true makes Dawn move the chosen media to the
        front of the list, so after closing the viewer on image 7 the PDP
        counter always read 1 — the media really was first by then. Dawn's own
        thumbnail clicks pass false for the same reason.
      */
      gallery.setActiveMedia(item.getAttribute('data-media-id'), false);
    }

    if (window.MutationObserver) {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          if (records[i].attributeName !== 'open') continue;
          if (modal.hasAttribute('open')) {
            // Dawn's showActiveMedia() has already marked the opener's slide.
            syncRailOrder();
            show(indexOfActive());
          } else {
            if (typeof modal.svResetZoom === 'function') modal.svResetZoom(false);
            syncBack();
          }
        }
      }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    }

    syncRailOrder();
    show(indexOfActive(), false);
  }


  /* ---- Mobile gallery position indicator ---------------------------------
     Reads Dawn, never counts for itself.

     SliderComponent already tracks the settled page and fires `slideChanged`
     with currentPage once scrolling comes to rest — so there is no second
     index here that could drift from what is on screen, which is exactly the
     failure the fullscreen viewer had. Variant changes and programmatic media
     switches go through Dawn too, and its own scroll handler emits the same
     event, so one listener covers every route.
     ---------------------------------------------------------------------- */
  function initGalleryCount() {
    var box = document.querySelector('[data-sv-gallery-count]');
    if (!box || box.dataset.svBound === 'true') return;
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    box.dataset.svBound = 'true';

    var current = box.querySelector('[data-sv-gcount-current]');
    var live = box.querySelector('[data-sv-gcount-live]');
    var slider = gallery.querySelector('slider-component');
    var total = gallery.querySelectorAll('.product__media-item').length;
    if (!total) return;

    function paint(page) {
      if (!page || page < 1 || page > total) return;
      if (current) current.textContent = page;
      // Written only on a settled change, so a screen reader is not narrated
      // through the swipe itself.
      if (live) live.textContent = 'Image ' + page + ' of ' + total;
      box.hidden = false;
    }

    if (slider) {
      slider.addEventListener('slideChanged', function (event) {
        if (event.detail && event.detail.currentPage) paint(event.detail.currentPage);
      });
    }

    /*
      Variant selection calls setActiveMedia without necessarily scrolling, so
      the slider's own event may not fire. This covers that path.

      IT MUST NOT FIGHT THE SCROLL HANDLER. Dawn toggles slide-visibility
      classes on these same elements during an ordinary swipe, which wakes this
      observer; recomputing from `is-active` then — which a swipe does not move
      — repainted the counter back to 1 immediately after slideChanged had
      correctly set it. Tracking the last `is-active` index and returning early
      when it has not changed leaves scroll-driven updates alone.
    */
    var lastActive = -1;
    if (window.MutationObserver) {
      new MutationObserver(function (records) {
        var touched = false;
        for (var i = 0; i < records.length; i++) {
          var t = records[i].target;
          if (records[i].attributeName === 'class' && t.classList && t.classList.contains('product__media-item')) {
            touched = true;
            break;
          }
        }
        if (!touched) return;

        var items = [].slice.call(gallery.querySelectorAll('.product__media-item'));
        var idx = -1;
        for (var j = 0; j < items.length; j++) {
          if (items[j].classList.contains('is-active')) { idx = j; break; }
        }
        if (idx === -1 || idx === lastActive) return;
        lastActive = idx;
        paint(idx + 1);
      }).observe(gallery, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    var startItems = [].slice.call(gallery.querySelectorAll('.product__media-item'));
    for (var k = 0; k < startItems.length; k++) {
      if (startItems[k].classList.contains('is-active')) { lastActive = k; paint(k + 1); return; }
    }
    lastActive = 0;
    paint(1);
  }


  /* ---- Landscape-phone media arrows --------------------------------------
     No index of their own: the current position is read from Dawn's own
     `is-active` item each time, and the change is handed straight back to
     setActiveMedia — the same call a thumbnail click makes. The counter then
     updates through the observer that already watches that class, so there is
     still exactly one source of truth for which media is showing.
     ---------------------------------------------------------------------- */
  function initLandscapeNav() {
    var nav = document.querySelector('[data-sv-lsnav]');
    if (!nav || nav.dataset.svBound === 'true') return;
    var gallery = document.querySelector('media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
    nav.dataset.svBound = 'true';

    var prev = nav.querySelector('[data-sv-lsnav-prev]');
    var next = nav.querySelector('[data-sv-lsnav-next]');

    function items() {
      return [].slice.call(gallery.querySelectorAll('.product__media-item'));
    }

    function currentIndex() {
      var list = items();
      for (var i = 0; i < list.length; i++) {
        if (list[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function syncEnds() {
      var list = items();
      var i = currentIndex();
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= list.length - 1;
    }

    function step(delta) {
      var list = items();
      var target = currentIndex() + delta;
      if (target < 0 || target >= list.length) return;
      var id = list[target].getAttribute('data-media-id');
      if (!id) return;
      // prepend:false — true reorders the list and breaks positional meaning.
      gallery.setActiveMedia(id, false);
      syncEnds();
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    // Variant changes move the active media without touching these buttons.
    if (window.MutationObserver) {
      new MutationObserver(syncEnds).observe(gallery, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    /*
      Size the overlay to the gallery, not to its containing block. The wrapper
      that positions these controls also contains the related-products row, so
      it is several times taller than the image — measured 1798px against a
      372px gallery, which put the arrows 900px down the page.
    */
    function measure() {
      var rect = gallery.getBoundingClientRect();
      var host = nav.offsetParent || nav.parentElement;
      var hostRect = host ? host.getBoundingClientRect() : { top: rect.top };
      nav.style.top = Math.round(rect.top - hostRect.top) + 'px';
      nav.style.height = Math.round(rect.height) + 'px';
      var count = document.querySelector('[data-sv-gallery-count]');
      if (count) {
        count.style.setProperty(
          '--sv-stage-bottom',
          Math.round(rect.top - hostRect.top + rect.height) + 'px'
        );
      }
    }

    var measureTimer;
    function scheduleMeasure() {
      clearTimeout(measureTimer);
      measureTimer = setTimeout(measure, 120);
    }
    window.addEventListener('resize', scheduleMeasure);
    window.addEventListener('orientationchange', scheduleMeasure);
    if (window.ResizeObserver) new ResizeObserver(scheduleMeasure).observe(gallery);

    measure();
    syncEnds();
  }

  function initWatchCount() {
    document.addEventListener('savendo:counts', function (event) {
      var count = event.detail && Number(event.detail.watchers);
      document.querySelectorAll('[data-sv-watch-count]').forEach(function (el) {
        if (isFinite(count) && count > 0) {
          el.textContent = count;
          el.hidden = false;
        } else {
          el.hidden = true;
        }
      });
    });
  }

  function init() {
    initWatchCount();
    document.querySelectorAll('media-gallery.savendo-gallery').forEach(initGallery);
    initStickyAtc();
    initWatch();
    initGalleryControls();
    initInlineZoom();
    initModalGallery();
    initGalleryCount();
    initLandscapeNav();
    initDescClamp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // product-info.js re-renders the buy box (and gallery) on variant change.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('variant:change', init);
})();
